<template>
    <div class="field">
        <label class="label">Lot numbers</label>
        <div class="control">
            <multi-select v-model="lots"
                          :close-on-select="false"
                          :options="existingLots"
                          :multiple="true"
                          placeholder="Type lot number"
                          :taggable="true"
                          @tag="addLot"
                          @remove="removeLot">
            </multi-select>
        </div>
    </div>
</template>

<script>
    import MultiSelect from 'vue-multiselect';
    export default {
        components: {
            MultiSelect
        },
        data () {
            return {
                existingLots: []
            }
        },
        computed: {
            lots: {
                get: function () {
                    return this.$store.getters.getQueryLots
                },
                set: function () {

                }
            }
        },
        methods: {
            addLot(value) {
                this.$store.dispatch('handleQueryLots', value)
            },
            removeLot(value) {
                this.$store.dispatch('removeLotFromQuery', value)
            }
        }
    }
</script>


<style scoped>
    .field {
        margin-top: 10px;
    }

    input:focus {
        outline:none;
    }
    .tags-input input{
        height: 100% !important;
        width: 250px !important;
        border-style: none !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/LotNumberInput.vue